var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-wrp-outer",style:({
    'background-color':_vm.$route.meta.logo.background
})},[_c('div',{staticClass:"content-box header-wrp-inner"},[_c('router-link',{staticClass:"header-bh-txt",attrs:{"to":"/bh"}},[_vm._v("B\"H")]),_c('logo'),_c('menu-trigger')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }